import React, { PropsWithChildren, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useSnapshot } from "valtio";
import styles from "./Layout.module.css";
import { Outlet, useLocation } from "react-router";
import Foot from "./Foot";
import Sidebar from "@/components/Layout/SidebarHistory";
import { supabaseAuthActions, supabaseAuthStore } from "@/utils/store/supabaseAuth";
import { fetchRecordingDurationConfigAndValue } from "@/services/recordingDurationService";

const LayoutN: React.FC<PropsWithChildren> = ({ children, ...rest }) => {
  // 只使用 Supabase 认证状态
  const supabaseAuth = useSnapshot(supabaseAuthStore);
  const location = useLocation();

  // 初始化 Supabase 认证状态
  useEffect(() => {
    supabaseAuthActions.init();
  }, []);

  // 初始化录音时长配置
  useEffect(() => {
    if (supabaseAuth.isAuthenticated && supabaseAuth.user?.id) {
      fetchRecordingDurationConfigAndValue(supabaseAuth.user.id);
    }
  }, [supabaseAuth.isAuthenticated, supabaseAuth.user?.id]);

  console.log("Supabase 认证状态:", supabaseAuth);
  console.log("location", location);

  return (
    <main className={styles.layout} {...rest}>
      <div className="bg-[#EBEEF5] min-h-screen flex flex-row w-full">
        {/* Sidebar固定高度 */}
        <div className="flex-shrink-0 h-screen">
          <Sidebar />
        </div>
        
        {/* 主内容区域 - 使用flex-1确保占满剩余空间 */}
          <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden">
            {/* <Head /> */}
            
            <div className="flex-1 p-3 overflow-y-auto">
              <Outlet />
            </div>
            
            {/* <Foot /> */}
          </div>
      </div>
    </main>
    );
};

export default LayoutN;
